import 'components/catalog.tag'
riot.tag2('news-list', '  <catalog object="News" search="true" sortable="true" cols="{cols}" reload="true" add="{permission(add, &quot;news&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;news&quot;, &quot;0001&quot;)}" dblclick="{permission(newsOpen, &quot;news&quot;, &quot;1000&quot;)}" store="news-list" new-filter="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">Категории</label>\n            <select class="form-control" data-name="idCategory" onclick="{parent.selectCategory}">\n              <option value="">Все</option>\n              <option each="{category, i in parent.newsCategories}" value="{category.id}" no-reorder>{category.title}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="image"><img if="{row.imageUrlPreview.trim() !== &quot;&quot;}" riot-src="{row.imageUrlPreview}"></datatable-cell>\n      <datatable-cell name="newsDate">{row.newsDateDisplay}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="name">{row.url}</datatable-cell>\n      <datatable-cell name="nameCategory">{row.nameCategory}</datatable-cell>\n      <datatable-cell name="localize">{row.localize}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'News';

self.cols = [{ name: 'id', value: '#' }, { name: 'image', value: 'Фото' }, { name: 'newsDate', value: 'Дата публ.' }, { name: 'name', value: 'Заголовок' }, { name: 'url', value: 'URL страницы' }, { name: 'nameCategory', value: 'Категории' }, { name: 'localize', value: 'Регион' }];

self.add = function () {
    if (self.selectedCategory) riot.route('/news/new?category=' + self.selectedCategory + '&name=' + self.selectedCategoryName);else riot.route('/news/new');
};

self.newsOpen = function (e) {
    riot.route('/news/' + e.item.row.id);
};

self.getNewsCategories = function () {
    API.request({
        object: 'NewsCategory',
        method: 'Fetch',
        success: function success(response) {
            self.newsCategories = response.items;
            self.update();
        }
    });
};

self.selectCategory = function (e) {
    self.selectedCategory = e.target.value || undefined;
    self.selectedCategoryName = '';
    self.newsCategories.forEach(function (item) {
        if (self.selectedCategory == item.id) {
            self.selectedCategoryName = item.title;
        }
    });
};

self.one('updated', function () {
    self.tags.catalog.on('reload', function () {
        self.getNewsCategories();
    });
});

observable.on('news-reload', function () {
    self.tags.catalog.reload();
});

self.getNewsCategories();
});


// WEBPACK FOOTER //
// ./pages/news/news-list.tag